module.exports = __tmimport("~endpoint:{controller:\'data\', action: \'iab_purpose_list\'}");